// @flow
import useQuery from 'hooks/useQuery'
import * as React from 'react'

import type { Mode } from '../types/mode'
import type { SharedContext } from '../types/shared-context'

type Props = {
  children: React.Node,
  isPacket: boolean,
  mode: Mode,
  isTablet: boolean,
  redirectOnSubmitted: boolean,
  afterSubmit: ?() => void,
}

export const ResourceSharedContext: React.Context<?SharedContext> =
  React.createContext(null)

function ResourceSharedProvider({
  children,
  isPacket,
  mode,
  isTablet,
  afterSubmit,
  redirectOnSubmitted,
}: Props): React.Node {
  const query = useQuery()

  const [formIndex, setFormIndex] = React.useState(0)
  const source = React.useMemo(() => {
    if (query.get('isKiosk') === 'true') {
      return 'kiosk'
    }
    if (isTablet) {
      return 'tablet'
    }

    return mode
  }, [isTablet, mode, query])

  const value = React.useMemo(
    () => ({
      isPacket,
      mode,
      formIndex,
      setFormIndex,
      isTablet,
      redirectOnSubmitted,
      afterSubmit,
      source,
    }),
    [
      afterSubmit,
      formIndex,
      isPacket,
      isTablet,
      mode,
      redirectOnSubmitted,
      source,
    ]
  )

  return (
    <ResourceSharedContext.Provider value={value}>
      {children}
    </ResourceSharedContext.Provider>
  )
}

export default ResourceSharedProvider
